import { Link } from "react-router-dom";
import { Package, Facebook, Linkedin, Twitter, Instagram, MapPin, Phone, Mail } from "lucide-react";

export default function Footer() {
  const year = 2013;
  return (
    <footer data-testid="site-footer" className="relative bg-slate-950 text-slate-300">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 grid grid-cols-1 md:grid-cols-4 gap-12">
        <div className="md:col-span-1">
          <Link to="/" className="flex items-center mb-5">
            <img
              src="/logo-dark-mode.png"
              alt="High Roller Consumer Goods Trading"
              className="h-14 w-auto"
            />
          </Link>
          <p className="text-sm leading-relaxed text-slate-400">
            A legacy of management excellence, a future of dynamic trade — distributing fast-moving consumer goods nationwide since 2013.
          </p>
          <div className="flex items-center gap-3 mt-6">
            {[
              { Icon: Linkedin, label: "linkedin", href: "https://linkedin.com" },
              { Icon: Twitter, label: "twitter", href: "https://twitter.com" },
              { Icon: Facebook, label: "facebook", href: "https://facebook.com" },
              { Icon: Instagram, label: "instagram", href: "https://instagram.com" },
            ].map(({ Icon, label, href }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noreferrer noopener"
                data-testid={`social-${label}`}
                className="w-9 h-9 rounded-full bg-white/5 hover:bg-blue-600 flex items-center justify-center transition-colors"
                aria-label={label}
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-heading text-white text-base font-semibold mb-5">Quick Links</h4>
          <ul className="space-y-3 text-sm">
            {[
              { label: "Home", to: "/" },
              { label: "Products", to: "/#products" },
              { label: "About Us", to: "/#about" },
              { label: "Services", to: "/#services" },
              { label: "Leadership", to: "/#leadership" },
              { label: "Our Suppliers", to: "/clients" },
              { label: "Contact", to: "/#contact" },
            ].map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="text-slate-400 hover:text-white transition-colors" data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-white text-base font-semibold mb-5">Our Services</h4>
          <ul className="space-y-3 text-sm text-slate-400">
            <li>Trading & Importation</li>
            <li>Management Solutions</li>
            <li>Modern Logistics</li>
            <li>High-Volume Distribution</li>
            <li>Retail & Wholesale Partnerships</li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-white text-base font-semibold mb-5">Get in Touch</h4>
          <ul className="space-y-4 text-sm text-slate-400">
            <li className="flex gap-3"><MapPin size={18} className="text-emerald-400 mt-0.5 shrink-0" /><span>L31 B18 Unit D Gemma Cruz St.<br/>BF Resort Village, Talon II<br/>Las Piñas City, Philippines</span></li>
            <li className="flex gap-3"><Phone size={18} className="text-emerald-400 mt-0.5 shrink-0" /><span>02 8522 4552</span></li>
            <li className="flex gap-3"><Mail size={18} className="text-emerald-400 mt-0.5 shrink-0" /><span>Billyjoe.dijamco@highrollerconsumergoodstrading.com</span></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
          <p data-testid="footer-copyright">© {year} High Roller Consumer Goods Trading. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white transition-colors">Terms of Service</a>
            <a href="#" className="hover:text-white transition-colors">Suppliers</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
